









import VQrCode from '@chenfengyuan/vue-qrcode'

import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'

import { qrCodeUrl } from '@/apiClient'

import { QrCode } from '@/models'

@Component({
  components: {
    VQrCode
  }
})
export default class QrCodeImage extends Vue {
  @Prop({ type: Object, required: true })
  readonly qrCode!: QrCode

  get qrCodeContent () {
    return qrCodeUrl(this.qrCode)
  }

  @Ref()
  readonly vQrCode!: VQrCode

  @Watch('qrCode', { immediate: true })
  onQrCodeChange () {
    this.$emit('change', this.qrCodeContent)
  }

  download () {
    const qrCodeElement = this.vQrCode.$el as HTMLCanvasElement
    const image = qrCodeElement.toDataURL()

    const link = document.createElement('a')

    link.download = `${this.qrCode.location} - ${this.qrCode.code}.png`
    link.href = image

    document.body.appendChild(link)

    link.click()
  }
}
